export default __webpack_public_path__ + "b8e97eaf74437496c03b7eb3636eca3a.png";